import {
    FaHandshake,
    FaPlaneDeparture,
    FaPhoneVolume,
    FaWheelchair,
    FaSuitcaseRolling,
    FaBicycle,
    FaCircleCheck,
    FaComments,
    FaTicket,
    FaBuilding,
    FaRing,
    FaMountainSun,
    FaCarSide,
    FaMapLocationDot,
} from "react-icons/fa6";
import { MdChildFriendly, MdSelfImprovement } from "react-icons/md";

const iconMap = {
    FaHandshake,
    FaPlaneDeparture,
    FaPhoneVolume,
    MdChildFriendly,
    FaWheelchair,
    FaSuitcaseRolling,
    FaBicycle,
    FaCircleCheck,
    FaComments,
    MdSelfImprovement,
    FaTicket,
    FaBuilding,
    FaRing,
    FaMountainSun,
    FaCarSide,
    FaMapLocationDot,
};

export default iconMap;
